var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "71609C4F-77C7-4BEA-A2AF-B2C23220B04E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quiz",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Header",
    transform: "translate(-320.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 360,
    height: 56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(320.000000, 16.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/20/Neutral/N100/Help",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4133589,9.74609736 L21.3943354,9.76432301 C21.3806888,9.77675408 21.3664282,9.78852266 21.3516042,9.79957792 L21.4133589,9.74609736 C21.3830652,9.776391 21.3501759,9.80250699 21.3154068,9.82444532 C21.3002842,9.83402051 21.2837836,9.84334694 21.266793,9.85183861 C21.2570012,9.85670379 21.2473696,9.86116401 21.2376443,9.86533724 C21.220574,9.87271343 21.2031082,9.87921763 21.1852577,9.88485553 C21.1718823,9.88901229 21.1578325,9.89286073 21.14368,9.8961552 C21.1298731,9.89944683 21.1161989,9.90209276 21.102358,9.90423412 C21.0852698,9.90682129 21.0678032,9.90871099 21.050296,9.90978597 C21.0456211,9.91010784 21.0411893,9.91032324 21.0367443,9.91048707 L21.0156564,9.91087505 L16.5156563,9.91087505 C16.2049962,9.91087505 15.9531563,9.65903522 15.9531563,9.34837505 C15.9531563,9.04477533 16.193679,8.79735269 16.4945684,8.78626303 L19.6575006,8.78550003 L17.4358838,6.56411637 C14.4337282,3.56196109 9.56627255,3.56196126 6.56411717,6.56411675 C3.56196179,9.56627223 3.56196179,14.4337279 6.56411717,17.4358834 C9.56627255,20.4380389 14.4337282,20.438039 17.4358838,17.4358838 C17.6555537,17.2162138 18.011709,17.2162139 18.2313789,17.4358838 C18.4510488,17.6555537 18.4510488,18.011709 18.2313789,18.2313789 C14.7898835,21.672874 9.21011721,21.6728738 5.76862202,18.2313785 C2.32712683,14.7898832 2.32712683,9.21011694 5.76862202,5.76862163 C9.17570226,2.36154127 14.678502,2.32747027 18.1274969,5.66640887 L18.231379,5.76862127 L20.4525006,7.99050003 L20.4531563,4.84837502 C20.4531563,4.54477531 20.693679,4.29735267 20.9945684,4.286263 L21.0156564,4.28587502 C21.3192561,4.28587502 21.5666787,4.52639767 21.5777684,4.82728706 L21.5781564,9.34837505 L21.5775146,9.37433449 C21.5768841,9.38805187 21.5757542,9.40175057 21.5741247,9.41540099 L21.5781564,9.34837505 C21.5781564,9.38957787 21.5737263,9.42974599 21.5653166,9.46842911 C21.5626114,9.48041276 21.559583,9.49242993 21.5561526,9.50435594 C21.5499466,9.52619628 21.542463,9.54724166 21.5338067,9.5676695 C21.530922,9.5743673 21.527963,9.58100157 21.5248692,9.58758822 C21.498609,9.64358094 21.4630459,9.6948509 21.4202839,9.73912233 L21.4133589,9.74609736 Z",
    id: "Combined-Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.2e2c1eee.svg";
export { ForwardRef as ReactComponent };